import script from "./resourceBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./resourceBanner.vue?vue&type=script&setup=true&lang=js"

import "./resourceBanner.vue?vue&type=style&index=0&id=07dc10c8&scoped=true&lang=css"

import exportComponent from "/workspace/cgsfront/cgs-office-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07dc10c8"]])

export default __exports__